type AddProps = {
    storeName: string,
    data: any,
}
type UpdateProps = AddProps & {oldNameToDelete?: string}
type DeleteProps = AddProps
type GetProps = {
    storeName: string,
    name?: string
}

type PromiseResponse = {
    requestRecord: any,
    currentRecords: any
}

export type RewriteProps = {
    deleteExisting?: boolean,
    schemas: {
        data: any,
        storeName: string
    }[]
}

export class DataHandler {
    constructor(private db: IDBDatabase) {
    }

    public add(props: AddProps) {
        const {storeName, data} = props
        return new Promise<PromiseResponse>((resolve, reject) => {
            const {transaction, store} = this.getDbObjects(storeName, "readwrite")

            store.add(data);
            const queryAll = store.getAll()

            transaction.oncomplete = () => {
                resolve({requestRecord: data, currentRecords: queryAll.result})
            }
            transaction.onerror = () => { reject() }
        })
    }

    public update(props: UpdateProps) {
        const {storeName, data, oldNameToDelete} = props
        return new Promise<PromiseResponse>((resolve, reject) => {
            const {transaction, store} = this.getDbObjects(storeName, "readwrite")

            store.put(data)
            if (oldNameToDelete) store.delete(oldNameToDelete)
            const queryAll = store.getAll()

            transaction.oncomplete = () => {
                resolve({requestRecord: data, currentRecords: queryAll.result})
            }
            transaction.onerror = () => { reject() }
        })
    }

    public delete(props: DeleteProps) {
        const {storeName, data} = props
        return new Promise<PromiseResponse>((resolve, reject) => {
            const {transaction, store} = this.getDbObjects(storeName, "readwrite")

            store.delete(data.name)
            const queryAll = store.getAll()

            transaction.oncomplete = () => {
                resolve({requestRecord: data, currentRecords: queryAll.result})
            }
            transaction.onerror = () => { reject() }
        })
    }

    public get(props: GetProps) {
        const {storeName, name} = props
        return new Promise<PromiseResponse>((resolve, reject) => {
            const {transaction, store} = this.getDbObjects(storeName)

            const query = name ? store.get(name) : store.getAll()

            query.onsuccess = () => {
                if (query.result === undefined) return reject(new Error("No entry found!"))
                resolve({requestRecord: name ? query.result : undefined, currentRecords: name ? undefined : query.result})
            };
            transaction.onerror = () => { reject() }
        })
    }

    public rewrite(props: RewriteProps) {
        const {schemas, deleteExisting = true} = props
        return new Promise<PromiseResponse>((resolve, reject) => {
            const storeNames = schemas.map(schema => schema.storeName)
            const transaction = this.db.transaction(storeNames, "readwrite");

            if (deleteExisting) {
                for (let i = 0; i < schemas.length; i++) {
                    const store = transaction.objectStore(schemas[i].storeName);
                    store.clear()
                }
            }

            for (let i = 0; i < schemas.length; i++) {
                const store = transaction.objectStore(schemas[i].storeName);
                const data = schemas[i].data
                for (let j = 0; j < data.length; j++) {
                    store.add(data[j])
                }
            }

            const queryAllRequests: IDBRequest<any[]>[] = []

            for (let i = 0; i < schemas.length; i++) {
                const store = transaction.objectStore(schemas[i].storeName);
                queryAllRequests.push(store.getAll())
            }


            transaction.oncomplete = () => {
                resolve({requestRecord: undefined, currentRecords: queryAllRequests.map((queryAll => queryAll.result))})
            }
            transaction.onerror = () => { reject() }
        })
    }

    private getDbObjects(storeName: string, readAccess?: 'readonly' | 'readwrite') {
        const transaction = this.db.transaction(storeName, readAccess ? readAccess : "readonly");
        const store = transaction.objectStore(storeName);
        return {transaction, store}
    }
}
